import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

function Developmentprocess({ data }) {
  const [activeTab, setActiveTab] = useState(1);

  function displayTab(tabNumber) {
    setActiveTab(tabNumber);
  }

  return (
    <section className="developmemt_proces p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="example" data-text="Process">
              <h2>Our Healthcare Mobile Application Development Process</h2>
            </div>
            <div>
              <p>
                As a top healthcare mobile app development company, we
                comprehend the vital value of providing high-quality healthcare
                mobile apps that address end customers' key concerns. Our
                healthcare mobile app development process is meticulously
                planned, assuring the success of your healthcare app while
                conforming to industry norms and laws.
              </p>
              <h4>
                Here's an overview of our comprehensive healthcare app
                development process:
              </h4>
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="swiper_main">
            <Swiper
              spaceBetween={0}
              modules={[Pagination, Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              breakpoints={{
                1400: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 4,
                },
                900: {
                  slidesPerView: 3,
                },
                500: {
                  slidesPerView: 2,
                },
                100: {
                  slidesPerView: 1,
                },
              }}
            >
              <SwiperSlide
                onClick={() => {
                  displayTab(1);
                }}
                className={`tabs ${activeTab === 1 ? "active" : ""}`}
              >
                <span>Project Analysis & Planning</span>
              </SwiperSlide>
              <SwiperSlide
                onClick={() => {
                  displayTab(2);
                }}
                className={`tabs ${activeTab === 2 ? "active" : ""}`}
              >
                <span>Design</span>
              </SwiperSlide>
              <SwiperSlide
                onClick={() => {
                  displayTab(3);
                }}
                className={`tabs ${activeTab === 3 ? "active" : ""}`}
              >
                <span>Agile Development</span>
              </SwiperSlide>
              <SwiperSlide
                onClick={() => {
                  displayTab(4);
                }}
                className={`tabs ${activeTab === 4 ? "active" : ""}`}
              >
                <span>Integration with Strategy</span>
              </SwiperSlide>
              <SwiperSlide
                onClick={() => {
                  displayTab(5);
                }}
                className={`tabs ${activeTab === 5 ? "active" : ""}`}
              >
                <span>Rigorous Testing</span>
              </SwiperSlide>
              <SwiperSlide
                onClick={() => {
                  displayTab(6);
                }}
                className={`tabs ${activeTab === 6 ? "active" : ""}`}
              >
                <span>Implementation & Development</span>
              </SwiperSlide>
              <SwiperSlide
                onClick={() => {
                  displayTab(7);
                }}
                className={`tabs ${activeTab === 7 ? "active" : ""}`}
              >
                <span>Ongoing Maintenance & Evolution</span>
              </SwiperSlide>
            </Swiper>

            <div
              className={activeTab === 1 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                During this initial phase, we work closely with you to
                understand your vision, goals, and target audience. Our team
                collaborates with you to define the app's features, scope, and
                timeline. We gather the required data through primary and
                secondary research and use it in identifying market trends, user
                preferences, and competition analysis. According to the results,
                we make any changes to your concept and create a comprehensive
                project plan for its implementation.
              </p>
            </div>
            <div
              className={activeTab === 2 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                We believe that the best quality a digital healthcare solution
                can offer is a superior user experience. Our design team built a
                user-friendly and intuitive app interface to attract users by
                providing a smooth patient and doctor experience.
              </p>
            </div>
            <div
              className={activeTab === 3 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                Our skilled team of mobile healthcare app developers prioritizes
                both front-end and back-end development to create robust and
                scalable solutions. Using the Agile development strategy, we
                divide the project into smaller iterations, enabling us to
                deliver results swiftly and adapt to changes flawlessly.
              </p>
            </div>
            <div
              className={activeTab === 4 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                We integrate the mobile application with your health information
                infrastructure to facilitate healthcare processes. Our technical
                team is well-versed in integration protocols for Electronic
                Health Records (EHR/EMR), Radiology Information Systems (RIS),
                Laboratory Information Systems (LIS), Revenue Cycle Management
                (RCM), and other similar systems.
              </p>
            </div>
            <div
              className={activeTab === 5 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                Our medical app developers carry out in-depth and exhaustive
                testing to recognize and correct any defects. We cover all kinds
                of testing such as functionality testing, performance testing,
                security testing, and user acceptance testing for our products.
                We embrace industry standards like the HIPAA Act, the HITech
                Act, NCPDP D.0, and FDA regulations.
              </p>
            </div>
            <div
              className={activeTab === 6 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                Our team assists in deploying the healthcare app into your IT
                environment, ensuring compatibility and smooth integration. Once
                the app has passed the testing phase, we work closely with your
                organization to ensure a seamless implementation. We provide
                inclusive training and support to your staff, enabling a
                successful app adoption within your healthcare organization or
                software product company.
              </p>
            </div>
            <div
              className={activeTab === 7 ? "d-block tab_txt" : "d-none tab_txt"}
            >
              <p>
                Once your app is deployed, we connect with you to incorporate
                new features, improve performance, and make sure the app stays
                current with industry standards and regulations We also actively
                listen to user feedback. Our staff will also be available to
                assist with any further maintenance and support requirements
                that may come up with your healthcare app solution.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Developmentprocess;
